import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
//
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { createStyles, makeStyles } from "@material-ui/styles";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import IconButtonGen from "../../../common/components/iconButton/IconButtonGen";
//
import "./FullScreen.scss";

const useStyles = makeStyles((theme) =>
  createStyles({
    rootWrapper: {},
    root: {},
    iconButton: {
      color: "#121212",
    },
  })
);

const FullScreen = ({
  fullScreenEle,
  isFullScreen,
  onFullScreen,
  onExitFullScreen,
  iconButtonStyle,
  IconButtonWrapper,
  iconSrc,
  iconActiveSrc,
  iconAlt,
  variant,
  toolTipTitle,
  tooltipPlacement,
}) => {
  const classes = useStyles();

  //
  const [localIsFullScreen, setLocalIsFullScreen] = useState(false);

  const handleShow = (_isFullScreen) => !_isFullScreen;

  useEffect(() => {
    if (isFullScreen !== null && isFullScreen !== undefined) {
      setLocalIsFullScreen(isFullScreen);
    }
  }, [isFullScreen]);

  const requestFullScreen = (ele) => {
    const de = ele;
    if (!ele) return;
    setLocalIsFullScreen(true);
    if (de.requestFullscreen) {
      de.requestFullscreen();
    } else if (de.mozRequestFullScreen) {
      de.mozRequestFullScreen();
    } else if (de.webkitRequestFullScreen) {
      de.webkitRequestFullScreen();
    }
  };

  const exitFullscreen = () => {
    const de = document;
    setLocalIsFullScreen(false);
    if (de.exitFullscreen) {
      de.exitFullscreen();
    } else if (de.mozCancelFullScreen) {
      de.mozCancelFullScreen();
    } else if (de.webkitCancelFullScreen) {
      de.webkitCancelFullScreen();
    }
  };

  const handleBtnClick = () => {
    // document.body 下有 #root 跟 #instruction-modal
    // 所以 request fullscreen 時, 要以父層 document.body 為 request 對象

    if (!localIsFullScreen) {
      requestFullScreen(fullScreenEle);
      if (onFullScreen) onFullScreen();
    } else {
      exitFullscreen();
      if (onExitFullScreen) onExitFullScreen();
    }
  };

  useEffect(() => {
    const handleFullScreen = (event) => {
      if (document.fullscreenElement) {
        setLocalIsFullScreen(true);
        if (onFullScreen) onFullScreen();
      } else {
        // eslint-disable-next-line no-lonely-if
        setLocalIsFullScreen(false);
        if (onExitFullScreen) onExitFullScreen();
      }
    };
    document.addEventListener("fullscreenchange", handleFullScreen, false);
    return () =>
      window.removeEventListener("fullscreenchange", handleFullScreen, false);
  }, []);

  const iconButtonEle =
    (iconSrc || iconActiveSrc) &&
    ((
      <IconButtonGen
        onClick={handleBtnClick}
        sx={{ ...(iconButtonStyle || {}) }}
        iconSrc={iconSrc}
        iconActiveSrc={iconActiveSrc}
        iconAlt={iconAlt}
        variant={variant}
        toolTipTitle={toolTipTitle}
        tooltipPlacement={tooltipPlacement}
      >
        <FullscreenIcon sx={{ fontSize: 35 }} />
      </IconButtonGen>
    ) || (
      <IconButton>
        <FullscreenIcon sx={{ fontSize: 35 }} />
      </IconButton>
    ));

  const getElement = () => {
    if (IconButtonWrapper && !(iconSrc || iconActiveSrc) && !toolTipTitle)
      return <IconButtonWrapper>{iconButtonEle}</IconButtonWrapper>;
    return iconButtonEle;
  };

  return handleShow(localIsFullScreen) && <div>{getElement()}</div>;
};

FullScreen.propTypes = {
  fullScreenEle: PropTypes.any,
  isFullScreen: PropTypes.bool,
  onFullScreen: PropTypes.func,
  onExitFullScreen: PropTypes.func,
  iconButtonStyle: PropTypes.objectOf(PropTypes.any),
  IconButtonWrapper: PropTypes.func,
  iconSrc: PropTypes.string,
  iconActiveSrc: PropTypes.string,
  iconAlt: PropTypes.string,
  variant: PropTypes.string,
  toolTipTitle: PropTypes.string,
  tooltipPlacement: PropTypes.string,
};

FullScreen.defaultProps = {
  fullScreenEle: null,
  isFullScreen: false,
  onFullScreen: () => null,
  onExitFullScreen: () => null,
  iconButtonStyle: undefined,
  IconButtonWrapper: undefined,
  iconSrc: undefined,
  iconActiveSrc: undefined,
  iconAlt: undefined,
  variant: undefined,
  toolTipTitle: undefined,
  tooltipPlacement: undefined,
};

export default FullScreen;
